import { apiClient } from './apiClient';
import { Payment, CreatePaymentRequest, OutstandingAmountResponse } from '../types/payment';
import { UnpaidInvoice } from '../types/unpaidInvoice';

export const paymentService = {
  // Получить платежи по инвойсу
  getInvoicePayments: async (companyId: string, invoiceId: string): Promise<Payment[]> => {
    const response = await apiClient.get(`/companies/${companyId}/invoices/${invoiceId}/payments`);
    return response.data;
  },

  // Создать платеж
  createPayment: async (companyId: string, invoiceId: string, paymentData: CreatePaymentRequest): Promise<Payment> => {
    const response = await apiClient.post(`/companies/${companyId}/invoices/${invoiceId}/payments`, paymentData);
    return response.data;
  },

  // Подтвердить платеж
  confirmPayment: async (companyId: string, invoiceId: string, paymentId: string): Promise<Payment> => {
    const response = await apiClient.put(`/companies/${companyId}/invoices/${invoiceId}/payments/${paymentId}/confirm`);
    return response.data;
  },

  // Отменить платеж
  cancelPayment: async (companyId: string, invoiceId: string, paymentId: string): Promise<Payment> => {
    const response = await apiClient.put(`/companies/${companyId}/invoices/${invoiceId}/payments/${paymentId}/cancel`);
    return response.data;
  },

  // Получить остаток к доплате
  getOutstandingAmount: async (companyId: string, invoiceId: string): Promise<OutstandingAmountResponse> => {
    const response = await apiClient.get(`/companies/${companyId}/invoices/${invoiceId}/payments/outstanding`);
    return response.data;
  },

  // Сопоставить платеж с банковской транзакцией
  matchPaymentToTransaction: async (companyId: string, invoiceId: string, paymentId: string, bankTransactionId: string): Promise<Payment> => {
    const response = await apiClient.put(`/companies/${companyId}/invoices/${invoiceId}/payments/${paymentId}/match`, {
      bankTransactionId
    });
    return response.data;
  },

  // Получить ожидающие платежи пользователя
  getPendingPayments: async (): Promise<Payment[]> => {
    const response = await apiClient.get('/payments/pending');
    return response.data;
  },

  // Получить неоплаченные инвойсы пользователя
  getUnpaidInvoices: async (): Promise<UnpaidInvoice[]> => {
    const response = await apiClient.get('/payments/pending');
    return response.data;
  }
};
